module.exports = __webpack_public_path__ + "assets/img/ic-intro-vvip.d09d05ac.png";